
import { RevBreadcrumb } from '@ds/components/Breadcrumb'
import { RevContainer } from '@ds/components/Container'
import { mapGetters } from 'vuex'

import { PAYMENT_ADVERTISING_TYPES } from '@payment'
import TrustList from '@reassurance/components/TrustList'

import NoResultsBanner from '../../../../components/NoResults/Banner'
import NoResultsButton from '../../../../components/NoResultsButton'
import SearchParams from '../../../../utils/SearchParams'

import LPBreadcrumbSkeleton from './components/LPBreadcrumbSkeleton.vue'

export default {
  components: {
    LPBreadcrumbSkeleton,
    NoResultsBanner,
    NoResultsButton,
    RevBreadcrumb,
    RevContainer,
    TrustList,
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
      filterWhitelist: 'landingSearch/filterWhitelist',
      landingBreadcrumb: 'landing/breadcrumb',
      ratings: 'rates/landing/get',
      searchHasResults: 'landingSearch/hasResults',
    }),

    ADVERTISING_LANDING: () => PAYMENT_ADVERTISING_TYPES.LANDING,

    shouldDisplayReassurance() {
      return (
        this.experiments.removeReassuranceBanner !== 'withoutReassuranceBanner'
      )
    },

    breads() {
      return this.landingBreadcrumb.map((bread) => {
        if (!bread.link) {
          return bread
        }

        return {
          ...bread,
          slug: {
            ...bread.link,
            params: {
              ...bread.link.params,
              slugV2: bread.link?.params?.slugV2,
            },
          },
        }
      })
    },

    searchParams() {
      const { query, hash, params, name } = this.$route

      const context = {
        source: name,
        id: params.uuid,
      }

      return new SearchParams({
        query,
        hash,
        context,
        paramsWhitelist: this.filterWhitelist,
      })
    },
  },
}
